import { QueryKey } from '@mint-lib/query-client';

interface NestedQueryKeysFactories {
  [key: string]: QueryKeysFactoryLeaf | NestedQueryKeysFactories;
}

type QueryKeysFactoryLeaf = QueryKey | ((...args: never[]) => QueryKey);

// Function to recursively remove falsy query keys
export function removeFalsyQueryKeys(
  queryKeysFactories: NestedQueryKeysFactories[string],
) {
  // If object is a function, wrap it in another function to apply.filter(Boolean)
  if (typeof queryKeysFactories === 'function') {
    return function (this: unknown, ...args: unknown[]) {
      return queryKeysFactories
        .bind(this)(...(args as never[]))
        .filter(Boolean);
    };
  }

  // If object is an array, apply .filterBoolean if it exists
  if (Array.isArray(queryKeysFactories)) {
    return queryKeysFactories.filter(Boolean);
  }

  // If object is an object, recursively transform its properties
  if (isNestedQueryKeysFactories(queryKeysFactories)) {
    const transformedObj: NestedQueryKeysFactories = {};
    for (const key in queryKeysFactories) {
      transformedObj[key] = removeFalsyQueryKeys(queryKeysFactories[key]);
    }
    return transformedObj;
  }

  // Otherwise, return object as it is
  return queryKeysFactories;
}

const isNestedQueryKeysFactories = (
  input: unknown,
): input is NestedQueryKeysFactories =>
  typeof input === 'object' && input !== null;
